<template>
  <div
    class="change-select-card"
    :class="{active:isSelect}"
  >
    <div
      class="change-select-card_select-btn"
      @click="$_selectClick()"
    >
      <i
        v-if="!isSelect"
        class="icon-check-box-outline-blank select-btn"
      />
      <i
        v-else
        class="icon-check-box select-btn"
      />
    </div>
    <div class="change-select-card_content">
      <div class="change-select-card_content-title-wrap">
        <p class="change-select-card_content-title">
          {{ title }}
        </p>
        <WsTextButton001
          v-if="!collapseActive && !systemSelect"
          no-padding
          primary
          font-size-xs
          bold
          @click="$_slideUp()"
        >
          {{ $t('查看說明') }}
        </WsTextButton001>
        <WsTextButton001
          v-if="collapseActive && !systemSelect"
          no-padding
          primary
          font-size-xs
          bold
          @click="$_slideDown()"
        >
          {{ $t('收起說明') }}
        </WsTextButton001>
      </div>
      <StateDropdownSelectClassification
        v-if="systemSelect && isSelect"
        :value="systemSubclasses"
        outline
        required
        rules="required"
        :title="$t('領域')"
        :menu="_systemClassMenu"
        @input="$_systemSelect($event)"
      />
      <LlState
        v-if="!systemSelect || isSelect"
        :value="value"
        type="textarea"
        :title="$t('敘述')"
        required
        rules="required"
        :placeholder="`${$t('若涉及此項變更，請詳細說明因素')}；${$t('若不涉及變更也請於此輸入“不涉及”')}`"
        :min-height="46"
        @input="$emit('input',$event)"
      />
      <slide-up-down
        class="change-select-card_content_collapse-content"
        :active="collapseActive"
        :duration="500"
      >
        <div
          v-if="description"
          class="collaple-content-item"
        >
          <div class="collaple-content-item_title-wrap">
            <i class="collaple-content-item_icon icon-warning" />
            <p class="collaple-content-item_title">
              {{ $t('說明') }}
            </p>
          </div>
          <div class="collaple-content-item_text">
            {{ description }}
          </div>
        </div>
        <ImageList
          v-if="images.length > 0"
          small
          :image-list="images"
          :margin-top="8"
        />
        <div
          v-if="attaches.length > 0"
          class="collaple-content-item"
        >
          <div class="collaple-content-item_title-wrap">
            <i class="collaple-content-item_icon icon-attachment" />
            <p class="collaple-content-item_title">
              {{ $t('附件') }}
            </p>
          </div>
          <LlFileList
            two-item
            narrow
            :attaches="attaches"
            :margin-top="10"
          />
        </div>
        <div
          v-if="articles.length > 0"
          class="collaple-content-item"
        >
          <div class="collaple-content-item_title-wrap">
            <i class="collaple-content-item_icon icon-nav-law-outline" />
            <p class="collaple-content-item_title">
              {{ $t('法規依據') }}
            </p>
          </div>
          <LlLinkList
            :link-list="articles"
            :has-hide="false"
            :margin-top="10"
            @click="$_lawLinkClick($event)"
          />
        </div>
      </slide-up-down>
    </div>
  </div>
</template>
<script>
export default {
  name: "ChangeSelectCard",
  props: {
    title: {
      type: String,
      default: "",
    },
    images: {
      type: Array,
      default() {
        return [];
      },
    },
    attaches: {
      type: Array,
      default() {
        return [];
      },
    },
    articles: {
      type: Array,
      default() {
        return [];
      },
    },
    description: {
      type: String,
      default: "",
    },
    isSelect: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: "",
    },
    systemSelect: {
      type: Boolean,
      default: false,
    },
    systemSubclasses: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data: () => ({
    depiction: "",
    collapseActive: false,
  }),
  computed: {
    _allSystemClass() {
      if (!this.$store.state.model.systemClasses) {
        return [];
      } else {
        return this.$store.state.model.systemClasses;
      }
    },
    _systemClassMenu() {
      let menu = JSON.parse(JSON.stringify(this._allSystemClass));
      let menuData = [];
      menu.forEach((menuItem) => {
        let item = {};
        item.title = menuItem.name;
        item.menu = menuItem.system_subclasses;
        menuData.push(item);
      });
      menuData.forEach((menuItem, menuIndex) => {
        menuItem.menu.forEach((systemItem, systemIndex) => {
          let systemData = {};
          systemData.text = systemItem.name;
          systemData.value = systemItem.id;
          menuData[menuIndex].menu[systemIndex] = systemData;
        });
      });
      return menuData;
    },
  },
  watch: {
    _allSystemClass: {
      deep: true,
      immediate: true,
      handler() {
        this.$_setAllSystemClassesSelect();
      },
    },
  },
  methods: {
    $_slideUp() {
      this.collapseActive = true;
    },
    $_slideDown() {
      this.collapseActive = false;
    },
    $_lawLinkClick($event) {
      this.$_linkToArticlePage($event.act_id, $event.id);
    },
    $_linkToArticlePage(actId, id) {
      this.$router.push({
        path: `/act-content-main/${actId}`,
        query: {
          id: `article${id}`,
        },
      });
    },
    $_setAllSystemClassesSelect() {
      let allSystem = [];
      this._allSystemClass.forEach((systemClass) => {
        systemClass.system_subclasses.forEach((subclass) => {
          allSystem.push(subclass.id);
        });
      });
      this.$emit("select-system", allSystem);
    },
    $_systemSelect($event) {
      this.$emit("select-system", $event);
    },
    $_selectClick() {
      this.$emit("select-click");
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/change-select-card";
</style>